'use strict';
// @flow

import { connect } from 'react-redux';

import ManifestaNfe from './manifesta_nfe';

export default connect<*, *, *, *, *, *>()(ManifestaNfe);
